/**
 * @author Harish.R <harish.r@314ecorp.com>
 * @description Table
 */
import React from 'react';
import _ from 'lodash';
import { Table as AntDTable, Result, Button, TableProps } from 'antd';
import { ReloadOutlined } from '@ant-design/icons';

import NoContentFound from 'components/widgets/NoContentFound';

interface ITableProps extends TableProps<AnyType> {
	error?: boolean;
	reload?: VoidFunction;
}

/**
 * Table
 */
const Table: React.FC<ITableProps> = ({ error, reload, dataSource, ...restProps }) => {
	if (error) {
		const hasReload = _.isFunction(reload);
		return (
			<Result
				className='box-shadow-6'
				status='warning'
				title='Oops!'
				subTitle='Something went wrong! Please try after sometime.'
				extra={
					hasReload && (
						<Button type={'primary'} onClick={reload}>
							<ReloadOutlined style={{ marginRight: '2px' }} />
							{'Reload'}
						</Button>
					)
				}
			/>
		);
	}

	return <AntDTable dataSource={dataSource} size='middle' locale={{ emptyText: <NoContentFound /> }} {...restProps} />;
};

const renderPaginationTotal = (totalRows: number, range: [number, number]): React.ReactNode => {
	return `${range[0]}-${range[1]} of ${totalRows} items`;
};

export { renderPaginationTotal };
export default Table;
